import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { REDUCER, ACTION } from "@common/constants/redux";

const initialState = { filter: null };

const persistConfig = {
  key: REDUCER.TIME_CONFIG,
  storage: storage,
};

const timeConfigReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION.SET_TIME_CONFIG_FILTER:
      return {
        ...state,
        filter: payload,
      };
    default:
      return state;
  }
};

export default persistReducer(persistConfig, timeConfigReducer);
